import React, {useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'
import {Table, TableBody, TableHead, TableRow} from '@material-ui/core'
import TableCell from '@material-ui/core/TableCell'
import {makeStyles} from '@material-ui/core/styles'

import useInvoiceView from 'features/invoice/useInvoiceView'

import InvoiceViewStyle from 'pages/CustomerManagement/InvoiceView/Style'
import {USAGE_SUMMARY_HEAD} from 'pages/CustomerManagement/InvoiceView/constant'
import useProductManagement from 'features/productManagement/useProductManagement'

const useStyles = makeStyles(InvoiceViewStyle)

interface UsageSummaryProps {
  totalAmount?: number
}

function UsageSummary(props: UsageSummaryProps) {
  const {t, i18n} = useTranslation()
  const {totalAmount = 0} = props
  const classes = useStyles()
  const {usageSummaryTable} = useInvoiceView()
  const {listAllPackage} = useProductManagement()

  const getInfoPackage = (packageId: string) => {
    const item = listAllPackage?.find((pkg) => pkg.itemId === packageId)
    if (item) {
      return (
        item.displayInfos.find(
          (info) => info.langCode === (i18n.language === 'ko' ? 'ko' : 'en'),
        )?.name || ''
      )
    }
    return ''
  }

  const totals = usageSummaryTable.reduce(
    (acc, item) => {
      item.usageLogs.forEach(({usageQuantity, packagePrice}) => {
        acc.totalUse += usageQuantity
        acc.totalPrice += packagePrice
        acc.totalAmount += packagePrice * usageQuantity
      })
      return acc
    },
    {totalUse: 0, totalPrice: 0, totalAmount: 0},
  )

  return (
    <div className={classes.defaultBilling} style={{marginTop: 10}}>
      <div className={classes.defaultBillingTitle}>{t('IUsageSummary')}</div>
      <div className={classes.defaultBillingTable}>
        <Table>
          <TableHead>
            <TableRow>
              {USAGE_SUMMARY_HEAD.map((head) => (
                <TableCell
                  key={head.id}
                  className={`${classes.header} ${classes.backGroundHead}`}
                >
                  {t(head.label)}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {usageSummaryTable.map((item) =>
              item.usageLogs.map((usage, index) => (
                <TableRow key={`${usage.usageId}-${index}`}>
                  {index === 0 && (
                    <TableCell
                      className={classes.cell}
                      rowSpan={item.usageLogs.length}
                    >
                      {item.period}
                    </TableCell>
                  )}
                  {index === 0 && (
                    <TableCell
                      className={classes.cell}
                      rowSpan={item.usageLogs.length}
                    >
                      {item.goodsName}
                    </TableCell>
                  )}
                  <TableCell className={classes.cell}>
                    {getInfoPackage(usage.packageItemId)}
                  </TableCell>
                  <TableCell className={classes.cell}>
                    {usage.usageQuantity}
                  </TableCell>
                  <TableCell className={classes.cell}>
                    {usage.packagePrice}
                  </TableCell>
                  <TableCell className={classes.cell}>
                    {usage.packagePrice * usage.usageQuantity}
                  </TableCell>
                  <TableCell className={classes.cell} />
                </TableRow>
              )),
            )}
            <TableRow>
              <TableCell className={classes.cell} colSpan={3}>
                {t('ITotal')}
              </TableCell>
              <TableCell className={classes.cell}>{totals.totalUse}</TableCell>
              <TableCell className={classes.cell}>
                {totals.totalPrice}
              </TableCell>
              <TableCell className={classes.cell}>{totalAmount}</TableCell>
              <TableCell className={classes.cell} />
            </TableRow>
          </TableBody>
        </Table>
      </div>
    </div>
  )
}

export default UsageSummary
